import React, { useEffect, useRef, useState } from 'react';

// Import all Profile images (Desktop)
import img1 from '../assets/Profile/rainbowcraft profile img2.png';
import img2 from '../assets/Profile/rainbowcraft profile img6.jpeg';
import img3 from '../assets/Profile/rainbowcraft profile img4.jpeg';
import img4 from '../assets/Profile/rainbowcraft profile img5.jpeg';
import img5 from '../assets/Profile/rainbowcraft profile img1.png';
import img6 from '../assets/Profile/rainbowcraft profile img7.jpeg';
import img7 from '../assets/Profile/rainbowcraft profile img8.jpeg';
import img8 from '../assets/Profile/rainbowcraft profile img9.jpeg';
import img9 from '../assets/Profile/rainbowcraft profile img10.jpeg';
import img10 from '../assets/Profile/rainbowcraft profile img11.jpeg';
import img11 from '../assets/Profile/rainbowcraft profile img12.jpeg';

// Import all Profile Mobile images
import mobileImg1 from '../assets/Profile Mobile/rainbowcraft mprofile img1.jpeg';
import mobileImg2 from '../assets/Profile Mobile/rainbowcraft mprofile img2.jpeg';
import mobileImg3 from '../assets/Profile Mobile/rainbowcraft mprofile img3.png';
import mobileImg4 from '../assets/Profile Mobile/rainbowcraft mprofile img4.png';
import mobileImg5 from '../assets/Profile Mobile/rainbowcraft mprofile img5.png';
import mobileImg6 from '../assets/Profile Mobile/rainbowcraft mprofile img6.png';
import mobileImg7 from '../assets/Profile Mobile/rainbowcraft mprofile img7.png';
import mobileImg8 from '../assets/Profile Mobile/rainbowcraft mprofile img8.png';
import mobileImg9 from '../assets/Profile Mobile/rainbowcraft mprofile img9.png';
import mobileImg10 from '../assets/Profile Mobile/rainbowcraft mprofile img10.png';
import mobileImg11 from '../assets/Profile Mobile/rainbowcraft mprofile img11.png';
import mobileImg12 from '../assets/Profile Mobile/rainbowcraft mprofile img12.png';
import mobileImg13 from '../assets/Profile Mobile/rainbowcraft mprofile img13.png';
import mobileImg14 from '../assets/Profile Mobile/rainbowcraft mprofile img14.png';
import mobileImg15 from '../assets/Profile Mobile/rainbowcraft mprofile img15.png';
import mobileImg16 from '../assets/Profile Mobile/rainbowcraft mprofile img16.png';
import mobileImg17 from '../assets/Profile Mobile/rainbowcraft mprofile img17.png';
import mobileImg18 from '../assets/Profile Mobile/rainbowcraft mprofile img18.png';

import { ArrowRight } from 'lucide-react';

const heroImagesDesktop = [img1, img2, img3, img4, img5, img6, img7, img8, img9, img10, img11];
const heroImagesMobile = [
    mobileImg1, mobileImg2, mobileImg3, mobileImg4, mobileImg5, mobileImg6,
    mobileImg7, mobileImg8, mobileImg9, mobileImg10, mobileImg11, mobileImg12,
    mobileImg13, mobileImg14, mobileImg15, mobileImg16, mobileImg17, mobileImg18
];

function HeroNew() {
    const videoRef = useRef(null);
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const [prevImageIndex, setPrevImageIndex] = useState(0);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    const [isFirstLoad, setIsFirstLoad] = useState(true);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // Dynamically select image set
    const heroImages = isMobile ? heroImagesMobile : heroImagesDesktop;

    const nextImage = () => {
        setPrevImageIndex(currentImageIndex);
        setCurrentImageIndex((prevIndex) => (prevIndex + 1) % heroImages.length);
    };

    useEffect(() => {
        // Reset index when changing modes to avoid index overflow if mobile set is smaller
        setCurrentImageIndex(0);
        setPrevImageIndex(0);
    }, [isMobile]);

    useEffect(() => {
        // Image slider interval - start after first load
        const interval = setInterval(() => {
            setCurrentImageIndex((prevIndex) => {
                setPrevImageIndex(prevIndex);
                setIsFirstLoad(false); // Disable first load flag after first transition
                return (prevIndex + 1) % heroImages.length;
            });
        }, 3000);

        return () => clearInterval(interval);
    }, [isMobile, heroImages.length]);

    useEffect(() => {
        // Scroll animation
        const handleScroll = () => {
            const scrolled = window.pageYOffset;
            if (videoRef.current && scrolled < window.innerHeight) {
                videoRef.current.style.transform = `scale(${1 + scrolled * 0.0003})`;
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const animationTypes = [
        'anim-slice',
        'anim-shutters',
        'anim-wipe-angle'
    ];

    return (
        <section className="hero-new">
            <div className="hero-video-container" ref={videoRef}>
                <div className="hero-overlay"></div>
                {heroImages.map((img, index) => {
                    // Cycle through animation types
                    const animClass = animationTypes[index % animationTypes.length];

                    // Show previous image (stays visible) and current image (animating in)
                    const isActive = index === currentImageIndex;
                    const isPrevious = index === prevImageIndex;
                    const shouldShow = isActive || isPrevious;

                    // Skip animation for the very first image on initial load
                    const shouldAnimate = !isFirstLoad || index !== 0;

                    return (
                        <img
                            key={`${isMobile ? 'm' : 'd'}-${index}`}
                            src={img}
                            alt={`Rainbow Craft Background ${index + 1}`}
                            className={`hero-background-image ${shouldAnimate ? animClass : ''} ${isActive ? 'active' : ''}`}
                            style={{
                                opacity: shouldShow ? 1 : 0,
                                zIndex: isActive ? 2 : (isPrevious ? 1 : 0)
                            }}
                        />
                    );
                })}
                {/* SEO Hidden Heading */}
                <h1 style={{
                    position: 'absolute',
                    width: '1px',
                    height: '1px',
                    padding: 0,
                    margin: -1,
                    overflow: 'hidden',
                    clip: 'rect(0, 0, 0, 0)',
                    whiteSpace: 'nowrap',
                    border: 0
                }}>
                    Rainbow Craft Signs & Graphics LLC - Abu Dhabi Musaffah - Signage & Branding Services All Over UAE
                </h1>
            </div>

            {/* Navigation Arrows */}
            <button className="slider-arrow next" onClick={nextImage}>
                <ArrowRight size={32} />
            </button>
            <div
                className="scroll-indicator"
                onClick={() => {
                    window.scrollTo({
                        top: window.innerHeight,
                        behavior: 'smooth'
                    });
                }}
            >
                <span>SCROLL</span>
                <div className="scroll-line"></div>
            </div>
        </section>
    );
}

export default HeroNew;
